export const unauthenticated = isAuthenticated => !isAuthenticated;
export const authenticated = isAuthenticated => isAuthenticated;

export const profileSet = ( isAuthenticated, profile ) =>
    isAuthenticated && profile.fullname && profile.username;

export const profileNotSet = ( isAuthenticated, profile ) =>
    isAuthenticated && (!profile.fullname && !profile.username);
